import {DataInput} from "../models/DataCollectionPaneConfig";
import {settings} from "../../../../settings/settings-util";
import {VTree} from "virtual-dom";
import VText from "virtual-dom/vnode/vtext";
import h from "virtual-dom/h";


export const buildLabelText = (input: DataInput, classNames: typeof settings.classNames): VTree[] =>
{
    const values: VTree[] = [new VText(input.labeltext)];

    if (input.required === "true")
    {
        return [...values, h('div', { className: classNames.dataCollectionValidateRequiredSymbol }, [])];
    }

    return values;
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-feedback-overlay/src/elements/Label.ts